import { UNITS } from '@frontend/partviewer/src/constants';

export const enum EDITOR_MODES {
  SCALE = 'SCALE',
  LAYERS = 'LAYERS',
}

export const DEFAULT_SCALE = 1;
export const DEFAULT_UNITS = UNITS.IN;

// form select options for SetScalePanel
export const UNIT_OPTIONS = [
  {
    value: UNITS.IN,
    label: 'Inches',
  },
  {
    value: UNITS.MM,
    label: 'Millimeters',
  },
];
